<div class="app-loader" *ngIf="visible">
  <div class="overlay"></div>

  <div class="h-100 row align-items-center justify-content-center">
    <div class="loader"></div>
  </div>
</div>
